import PropTypes from "prop-types";
import Select from "react-select";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: '0.375rem', // ปรับให้ตรงกับ daisyUI (rounded-md)
    borderColor: state.isFocused ? '#2563eb' : '#d1d5db', // blue-600 เมื่อ focus, gray-300 เมื่อไม่ focus
    boxShadow: state.isFocused ? '0 0 0 1px #2563eb' : null,
    '&:hover': { borderColor: state.isFocused ? '#2563eb' : '#d1d5db' },
    minHeight: '3.05rem',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#9ca3af', // gray-400
  }),
  input: (provided) => ({
    ...provided,
    color: '#374151', // gray-700
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '0.375rem',
    marginTop: 4,
  }),
};


const EditUserModal = ({
  editUser,
  setEditUser,
  handleSaveEditUser,
  setShowEditUserModal,
  hospitalOptions,
  errors,
}) => {
  if (!editUser) return null;

  const selectedHospital = hospitalOptions.find(
    (option) => option.value === editUser.hospitalName
  ) || null;

  const handleHospitalChange = (selectedOption) => {
    setEditUser({ ...editUser, hospitalName: selectedOption ? selectedOption.value : "" });
  };

  return (
    <div className="modal modal-open">
      <div className="modal-box">
        <h3 className="font-bold text-lg">Edit User</h3>
        <div className="form-control mt-4">
            <label className="label">
              <span className="label-text">Hospital Name</span>
            </label>
            <Select
              styles={customStyles}
              options={hospitalOptions}
              value={selectedHospital}
              onChange={handleHospitalChange}
              placeholder="Select Hospital..."
              isClearable
            />
            {errors.hospitalName && <span className="text-error text-sm">{errors.hospitalName}</span>}
          </div>
        <div className="form-control">
          <label className="label">User Role</label>
          <select
            value={editUser.role}
            onChange={(e) =>
              setEditUser({ ...editUser, role: e.target.value })
            }
            className="select select-bordered"
          >
            <option value="user">Members</option>
            <option value="guest">Guest</option>
          </select>
          {errors.role && <span className="text-error text-sm">{errors.role}</span>}
        </div>
        <div className="form-control mt-2">
          <label className="label cursor-pointer">
            <span className="label-text">Status</span>
            <input
              type="checkbox"
              className="toggle toggle-success"
              checked={editUser.isActive}
              onChange={(e) =>
                setEditUser({
                  ...editUser,
                  isActive: e.target.checked,
                })
              }
            />
          </label>
        </div>
        {errors.isActive && <span className="text-error text-sm">{errors.isActive}</span>}
        <div className="modal-action">
          <button className="btn btn-primary" onClick={handleSaveEditUser}>
            Save
          </button>
          <button className="btn" onClick={() => setShowEditUserModal(false)}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
EditUserModal.propTypes = {
  editUser: PropTypes.object,
  setEditUser: PropTypes.func,
  handleSaveEditUser: PropTypes.func,
  setShowEditUserModal: PropTypes.func,
  hospitalOptions: PropTypes.array.isRequired,
  errors: PropTypes.object.isRequired,
};

export default EditUserModal;